import React from 'react';

const CpoLabel = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="146"
      height="13"
      viewBox="0 0 146 13"
      fill="none"
    >
      <path
        d="M140.942 10.2815C139.769 10.2815 138.518 10.0169 137.886 9.67669L138.266 8.31585C138.884 8.60565 140.047 8.80727 141.007 8.80727C141.865 8.80727 143.014 8.76946 143.014 8.25284C143.014 7.88743 142.408 7.74882 141.284 7.49681C139.769 7.15659 138.91 6.69038 138.91 5.70754C138.91 3.90567 140.766 3.43945 142.736 3.43945C143.759 3.43945 144.934 3.67886 145.704 4.04428L145.325 5.39253C144.669 5.10272 143.519 4.90111 142.698 4.90111C142.029 4.90111 140.942 4.95151 140.942 5.44293C140.942 5.79575 141.537 5.94695 142.673 6.19896C144.176 6.53918 145.06 7.00539 145.06 7.98823C145.06 9.84051 142.862 10.2815 140.942 10.2815Z"
        fill="#EB0D3F"
      />
      <path
        d="M134.05 10.092V9.42417C133.43 9.94078 132.458 10.2936 131.347 10.2936C129.92 10.2936 128.594 9.62576 128.594 8.26492C128.594 8.01291 128.632 7.68529 128.72 7.39548L129.793 3.62793H131.84L130.817 7.21907C130.753 7.42068 130.728 7.63489 130.728 7.8113C130.728 8.55473 131.322 8.81934 132.092 8.81934C132.9 8.81934 133.645 8.57993 134.214 8.18931L135.514 3.62793H137.574L135.729 10.092H134.05Z"
        fill="#EB0D3F"
      />
      <path
        d="M125.385 10.2563C124.059 10.2563 123.516 9.58847 123.516 8.68123C123.516 8.44183 123.553 8.17721 123.629 7.9126L125.612 0.969727H127.67L125.687 7.9126C125.649 8.0638 125.624 8.20241 125.624 8.31582C125.624 8.61823 125.801 8.76944 126.344 8.76944C126.647 8.76944 127.026 8.70643 127.241 8.61823L126.85 9.97908C126.521 10.1555 125.965 10.2563 125.385 10.2563Z"
        fill="#EB0D3F"
      />
      <path
        d="M112.206 12.7512L114.808 3.62837H116.551L116.487 4.3718C117.144 3.80478 118.091 3.42676 119.304 3.42676C121.198 3.42676 122.322 4.59861 122.322 6.21148C122.322 8.98358 119.822 10.294 117.661 10.294C116.601 10.294 115.729 10.105 115.111 9.79001L114.265 12.7512H112.206ZM118.534 4.92622C117.687 4.92622 116.904 5.15303 116.323 5.55624L115.464 8.51736C116.057 8.69377 116.727 8.79457 117.296 8.79457C118.912 8.79457 120.238 8.06375 120.238 6.40048C120.238 5.58144 119.721 4.92622 118.534 4.92622Z"
        fill="#EB0D3F"
      />
      <path
        d="M109.572 5.73221L110.166 3.62793H112.527L111.934 5.73221H109.572ZM108.334 10.092L108.928 7.98771H111.29L110.696 10.092H108.334Z"
        fill="#EB0D3F"
      />
      <path
        d="M99.5901 10.2437C97.3043 10.2437 95.8394 9.00884 95.8394 6.85416C95.8394 4.74988 97.2538 3.47723 99.6659 3.47723C100.588 3.47723 101.472 3.69143 102.078 4.08205V0.969727H103.328V10.0925H102.28L102.179 9.52547C101.56 9.94129 100.588 10.2437 99.5901 10.2437ZM99.8427 9.27346C100.701 9.27346 101.459 9.03405 102.078 8.64343V5.07749C101.459 4.68687 100.701 4.44746 99.8427 4.44746C98.0873 4.44746 97.1275 5.2539 97.1275 6.85416C97.1275 8.45442 98.0873 9.27346 99.8427 9.27346Z"
        fill="black"
      />
      <path
        d="M90.949 9.23499C92.1992 9.23499 92.9949 8.95778 93.7526 8.65537V9.65081C93.0201 9.99103 92.1109 10.243 90.81 10.243C88.259 10.243 87.0088 8.78138 87.0088 6.7653C87.0088 4.91303 88.3221 3.47656 90.6206 3.47656C92.8812 3.47656 94.1946 4.79962 94.1946 6.6267C94.1946 6.7905 94.182 7.00471 94.1694 7.11811H88.259C88.3474 8.40336 89.2062 9.23499 90.949 9.23499ZM90.6206 4.43421C89.3451 4.43421 88.3727 5.13983 88.2716 6.16047H92.9696C92.856 5.13983 91.8962 4.43421 90.6206 4.43421Z"
        fill="black"
      />
      <path
        d="M83.4463 10.0925V3.62844H84.6965V10.0925H83.4463ZM83.4463 2.33057V0.969727H84.6965V2.33057H83.4463Z"
        fill="black"
      />
      <path
        d="M76.0454 4.61111V3.62827H77.902V3.19985C77.902 1.7256 78.7733 0.818359 80.794 0.818359C81.5896 0.818359 82.1579 0.931764 82.562 1.08297V2.06581C82.1074 1.9146 81.4632 1.8264 80.8192 1.8264C79.5816 1.8264 79.1522 2.29262 79.1522 3.28806V3.62827H81.88V4.61111H79.1522V10.0923H77.902V4.61111H76.0454Z"
        fill="black"
      />
      <path
        d="M72.9756 10.0925V3.62844H74.2258V10.0925H72.9756ZM72.9756 2.33057V0.969727H74.2258V2.33057H72.9756Z"
        fill="black"
      />
      <path
        d="M65.2065 4.61133V3.62849H66.6589L66.8104 2.01562H67.846V3.62849H70.9653V4.61133H67.846V8.05127C67.846 8.94591 68.3007 9.23571 69.3362 9.23571C69.9171 9.23571 70.4476 9.12231 70.8643 8.9585V9.92874C70.397 10.1052 69.7529 10.2438 68.9573 10.2438C67.3913 10.2438 66.6083 9.66413 66.6083 8.21507V4.61133H65.2065Z"
        fill="black"
      />
      <path
        d="M59.4829 10.092V3.62795H60.6068L60.7079 4.7998C61.15 4.11938 61.895 3.50195 63.1453 3.50195C63.6126 3.50195 64.0167 3.56496 64.2946 3.66576V4.7746C63.9282 4.6738 63.4737 4.62339 62.9937 4.62339C61.6424 4.62339 61.011 5.41723 60.7332 5.88345V10.092H59.4829Z"
        fill="black"
      />
      <path
        d="M53.9994 9.23499C55.2496 9.23499 56.0452 8.95778 56.8029 8.65537V9.65081C56.0705 9.99103 55.1612 10.243 53.8604 10.243C51.3093 10.243 50.0591 8.78138 50.0591 6.7653C50.0591 4.91303 51.3725 3.47656 53.6709 3.47656C55.9316 3.47656 57.245 4.79962 57.245 6.6267C57.245 6.7905 57.2323 7.00471 57.2197 7.11811H51.3093C51.3978 8.40336 52.2566 9.23499 53.9994 9.23499ZM53.6709 4.43421C52.3955 4.43421 51.423 5.13983 51.3219 6.16047H56.0199C55.9063 5.13983 54.9465 4.43421 53.6709 4.43421Z"
        fill="black"
      />
      <path
        d="M45.4803 10.2435C42.5756 10.2435 40.4287 8.65587 40.4287 5.53095C40.4287 2.56983 42.5756 0.818359 45.3666 0.818359C46.3643 0.818359 47.4504 0.969566 48.246 1.30978V2.43123C47.3368 2.06581 46.377 1.9272 45.5434 1.9272C43.2576 1.9272 41.7547 3.11165 41.7547 5.53095C41.7547 8.22745 43.6616 9.14729 45.5055 9.14729C46.9705 9.14729 47.9303 8.89528 48.4481 8.70627V9.78992C47.8166 10.0419 46.8189 10.2435 45.4803 10.2435Z"
        fill="black"
      />
      <path
        d="M33.3486 10.0925V3.62844H35.3314V10.0925H33.3486ZM33.3486 2.6834V0.969727H35.3314V2.6834H33.3486Z"
        fill="#EB0D3F"
      />
      <path
        d="M26.4708 10.2941C24.1597 10.2941 22.7832 8.98364 22.7832 6.85416C22.7832 4.72468 24.1724 3.42683 26.6224 3.42683C27.5823 3.42683 28.4915 3.66623 29.0851 4.05685V0.969727H31.0678V10.0925H29.3377L29.1987 9.36166C28.5925 9.91608 27.557 10.2941 26.4708 10.2941ZM26.8623 8.74424C27.7969 8.74424 28.4283 8.59303 29.0851 8.24022V5.45551C28.4283 5.11529 27.7969 4.95149 26.8623 4.95149C25.5237 4.95149 24.8039 5.64452 24.8039 6.85416C24.8039 8.0638 25.5237 8.74424 26.8623 8.74424Z"
        fill="#EB0D3F"
      />
      <path
        d="M19.3227 10.092L19.1837 9.38636C18.6028 9.91558 17.6051 10.2684 16.557 10.2936C14.8772 10.2936 13.3618 9.73917 13.3618 7.43329V3.62793H15.3446V7.18128C15.3446 8.26492 15.837 8.78154 17.0368 8.78154C17.8451 8.78154 18.4639 8.59253 19.0701 8.23971V3.62793H21.0529V10.092H19.3227Z"
        fill="#EB0D3F"
      />
      <path
        d="M0.75 10.0925L5.54902 0.969727H7.67068L12.4697 10.0925H10.1839L9.19879 8.20241H3.98302L3.01058 10.0925H0.75ZM6.59722 2.93541L4.74076 6.62735H8.45368L6.59722 2.93541Z"
        fill="#EB0D3F"
      />
    </svg>
  );
};

export default CpoLabel;
